<template>
    <div class="progress-bar">
        <div class="progress" :style="{ width: percent }"></div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'progress-bar',
    computed: {
        ...mapGetters(['questionNumber', 'firstToCurrentPageAllAnswerNumber']),
        percent() {
            if (this.firstToCurrentPageAllAnswerNumber && this.questionNumber) {
                return `${(this.firstToCurrentPageAllAnswerNumber / this.questionNumber) * 100}%`;
            }
            return '0%';
        }
    }
};
</script>
<style lang="scss" scoped>
.progress-bar {
    width: 750px;
    height: 8px;
    background: rgba($color: #000000, $alpha: 0.1);
    position: relative;
    margin-top: 10px;
    .progress {
        height: 100%;
        background-color: #ffec00;
        border-radius: 0 100px 100px 0;
    }
}
</style>
